import React, { useEffect, useContext, useState } from "react";
import { AudioAppContext } from "../../contexts/AudioContext";
import Switch from "react-switch";
import { isMobileOrTablet } from "../Views/MobileClassRenderer";
import { isSafari, isIOS } from "react-device-detect";
import { GlobalPageDataContext } from "../../contexts/GlobalPageDataContext";
import { useRouter } from "next/router";
import { getVVColor } from "../../util/colorUtil";

export default function SoundMuteToggle({ useIconOnly = false }) {
  const router = useRouter();
  const { event, page } = router.query;
  const {
    mute,
    setMute,
    audioPlaybackAllowed,
    videoPlaybackAllowed,
    interactedWithVideo,
  } = useContext(AudioAppContext);
  const [canUnmute, setCanUnmute] = useState(getCanUnmute());
  const [hasVideo, setHasVideo] = useState(false);
  const { globalPageData } = useContext(GlobalPageDataContext);

  function toggleMute() {
    if (canUnmute) {
      setMute(!mute);
    }
  }

  function getHasVideo() {
    const getVideoLinkOrVideoFile = (page) =>
      page?.backgroundVideoLink
        ? page?.backgroundVideoLink
        : page?.backgroundVideoFile;

    let video = false;
    if (page) {
      video = getVideoLinkOrVideoFile(globalPageData?.[page]);
    } else {
      video = getVideoLinkOrVideoFile(globalPageData?.[event]);
    }

    return !!video;
  }

  function hasInteractedWithVideoIfVideoExists() {
    if (!hasVideo) return true;

    return interactedWithVideo;
  }

  function getCanUnmute() {
    if (isSafari || isIOS) {
      return hasInteractedWithVideoIfVideoExists();
    } else {
      return audioPlaybackAllowed && videoPlaybackAllowed;
    }
  }

  useEffect(() => {
    setHasVideo(getHasVideo());
  }, [globalPageData, page, event, interactedWithVideo, mute]);

  useEffect(() => {
    setCanUnmute(getCanUnmute());
  }, [
    mute,
    audioPlaybackAllowed,
    videoPlaybackAllowed,
    interactedWithVideo,
    hasVideo,
  ]);
  return (
    <>
      {!useIconOnly ? (
        <Switch
          height={isMobileOrTablet() ? 24 : 28}
          width={isMobileOrTablet() ? 46 : 56}
          onChange={(e) => setMute(!e)}
          checked={!mute && canUnmute}
          offColor={getVVColor("gray2")}
          onColor={getVVColor("primary")}
          className="toggle"
          uncheckedIcon={false}
          checkedIcon={false}
        />
      ) : (
        <div
          className="nav_main_btn nav_main_btn__mute"
          onClick={toggleMute}
          tabindex="0"
        >
          <>
            {!mute && canUnmute ? (
              <img src="/assets/sound-enable.svg" />
            ) : (
              <img src="/assets/sound-disable.svg" />
            )}
          </>
        </div>
      )}
    </>
  );
}
